// eslint-disable-next-line import/prefer-default-export
export const getCountDownText = (countDown: number) => {
  const minutes = Math.floor(countDown / 60)
  const seconds = countDown % 60

  // mm:ss
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}
